// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.resizeable-window-container {
    position: absolute;
    pointer-events: none;
}

div.resizeable-window {
    pointer-events: auto;
    background-color: var(--container-bg-color);
    box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.75);
    z-index: 8;
    border-radius: var(--border-radius);
}

div.resizeable-window-portal-container,
div.resizeable-window-portal-container > div {
    height: 100%;
}

div.resizeable-window-portal-container {
    padding: 0.25em;
    background-color: var(--container-bg-color);
}

div.resizeable-window-contents {
    display: flex;
    flex-direction: column;
    height: 100%;
}

div.resizeable-window-maximized {
    transform: none!important;
    left: 0!important;
    right: 0!important;
    top: 0!important;
    bottom: 0!important;
    width: initial!important;
    height: initial!important;
}

div.resizeable-window-minimized {
    height: 2.5em!important;
    min-height: 2.5em!important;
}

div.resizeable-window-minimized div.resizeable-window-body {
    padding: 0;
}

div.resizeable-window-docked-left {
    transform: none!important;
    left: 0!important;
    right: initial!important;
    top: 0!important;
    bottom: initial!important;
}

div.resizeable-window-docked-right {
    transform: none!important;
    left: initial!important;
    right: 0!important;
    top: 0!important;
    bottom: initial!important;
}

div.resizeable-window-split-left {
    transform: none!important;
    left: 0!important;
    right: initial!important;
    top: 0!important;
    bottom: 0!important;
    height: initial!important;
    max-height: initial!important;
}

div.resizeable-window-split-right {
    transform: none!important;
    left: initial!important;
    right: 0!important;
    top: 0!important;
    bottom: 0!important;
    height: initial!important;
    max-height: initial!important;
}

div.resizeable-window-docked-top {
    transform: none!important;
    left: 0!important;
    right: 0!important;
    top: 0!important;
    bottom: initial!important;
    width: initial!important;
    max-width: initial!important;
}

div.resizeable-window-docked-bottom {
    transform: none!important;
    left: 0!important;
    right: 0!important;
    top: initial!important;
    bottom: 0!important;
    width: initial!important;
    max-width: initial!important;
}

div.resizeable-window-fit-height {
    height: initial!important;
}

div.resizeable-window-titlebar {
    color: var(--titlebar-text-color);
    background-color: var(--titlebar-bg-color);
    flex: 0 0 2.5em;
    display: flex;
    align-items: center;
    padding: 0 0.5em;
    border-radius: var(--border-radius) var(--border-radius) 0px 0px;
}

div.resizeable-window-titlebar > div.spinner {
    flex: 0 0 auto;
    margin-right: 0.25em;
    width: 1.5em;
    height: 1.5em;
}

div.resizeable-window-titlebar > div.spinner > div {
    background-color: var(--titlebar-text-color);
}

span.resizeable-window-titlebar-icon {
    flex: 0 0 auto;
    margin-right: 0.25em;
}

span.resizeable-window-titlebar-title {
    font-weight: bold;
    flex: 1 1 auto;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}

span.resizeable-window-titlebar-control {
    flex: 0 0 auto;
    margin-left: 0.25em;
    font-size: large;
}

span.resizeable-window-titlebar-extra-control {
    flex: 0 0 auto;
    margin-right: 0.25em;
    font-size: large;
}

span.resizeable-window-titlebar-extra-control-active {
    background-color: var(--titlebar-text-color);
    color: var(--titlebar-bg-color);
}

div.resizeable-window-body {
    overflow: hidden;
    flex: 1 1 auto;
    cursor: default;
    flex: 1 1 auto;
    position: relative;
    border-radius: 0px 0px var(--border-radius) var(--border-radius);
}

div.dock-window > div.resizeable-window-body {
    margin: 0.25em;
}

div.resizeable-window-body-scrollable {
    overflow-y: auto;
}

div.resizeable-window-drag-shield {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    display: none;
    z-index: 1;
}
`, "",{"version":3,"sources":["webpack://./components/style/ResizeableWindow.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;IACpB,2CAA2C;IAC3C,2CAA2C;IAC3C,UAAU;IACV,mCAAmC;AACvC;;AAEA;;IAEI,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,2CAA2C;AAC/C;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,wBAAwB;IACxB,yBAAyB;AAC7B;;AAEA;IACI,uBAAuB;IACvB,2BAA2B;AAC/B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,wBAAwB;IACxB,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,wBAAwB;IACxB,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;IACzB,6BAA6B;AACjC;;AAEA;IACI,yBAAyB;IACzB,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;IACzB,6BAA6B;AACjC;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,wBAAwB;IACxB,4BAA4B;AAChC;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;IAClB,sBAAsB;IACtB,mBAAmB;IACnB,wBAAwB;IACxB,4BAA4B;AAChC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,iCAAiC;IACjC,0CAA0C;IAC1C,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,gEAAgE;AACpE;;AAEA;IACI,cAAc;IACd,oBAAoB;IACpB,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,4CAA4C;IAC5C,+BAA+B;AACnC;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,gEAAgE;AACpE;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,MAAM;IACN,SAAS;IACT,aAAa;IACb,UAAU;AACd","sourcesContent":["div.resizeable-window-container {\n    position: absolute;\n    pointer-events: none;\n}\n\ndiv.resizeable-window {\n    pointer-events: auto;\n    background-color: var(--container-bg-color);\n    box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.75);\n    z-index: 8;\n    border-radius: var(--border-radius);\n}\n\ndiv.resizeable-window-portal-container,\ndiv.resizeable-window-portal-container > div {\n    height: 100%;\n}\n\ndiv.resizeable-window-portal-container {\n    padding: 0.25em;\n    background-color: var(--container-bg-color);\n}\n\ndiv.resizeable-window-contents {\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n}\n\ndiv.resizeable-window-maximized {\n    transform: none!important;\n    left: 0!important;\n    right: 0!important;\n    top: 0!important;\n    bottom: 0!important;\n    width: initial!important;\n    height: initial!important;\n}\n\ndiv.resizeable-window-minimized {\n    height: 2.5em!important;\n    min-height: 2.5em!important;\n}\n\ndiv.resizeable-window-minimized div.resizeable-window-body {\n    padding: 0;\n}\n\ndiv.resizeable-window-docked-left {\n    transform: none!important;\n    left: 0!important;\n    right: initial!important;\n    top: 0!important;\n    bottom: initial!important;\n}\n\ndiv.resizeable-window-docked-right {\n    transform: none!important;\n    left: initial!important;\n    right: 0!important;\n    top: 0!important;\n    bottom: initial!important;\n}\n\ndiv.resizeable-window-split-left {\n    transform: none!important;\n    left: 0!important;\n    right: initial!important;\n    top: 0!important;\n    bottom: 0!important;\n    height: initial!important;\n    max-height: initial!important;\n}\n\ndiv.resizeable-window-split-right {\n    transform: none!important;\n    left: initial!important;\n    right: 0!important;\n    top: 0!important;\n    bottom: 0!important;\n    height: initial!important;\n    max-height: initial!important;\n}\n\ndiv.resizeable-window-docked-top {\n    transform: none!important;\n    left: 0!important;\n    right: 0!important;\n    top: 0!important;\n    bottom: initial!important;\n    width: initial!important;\n    max-width: initial!important;\n}\n\ndiv.resizeable-window-docked-bottom {\n    transform: none!important;\n    left: 0!important;\n    right: 0!important;\n    top: initial!important;\n    bottom: 0!important;\n    width: initial!important;\n    max-width: initial!important;\n}\n\ndiv.resizeable-window-fit-height {\n    height: initial!important;\n}\n\ndiv.resizeable-window-titlebar {\n    color: var(--titlebar-text-color);\n    background-color: var(--titlebar-bg-color);\n    flex: 0 0 2.5em;\n    display: flex;\n    align-items: center;\n    padding: 0 0.5em;\n    border-radius: var(--border-radius) var(--border-radius) 0px 0px;\n}\n\ndiv.resizeable-window-titlebar > div.spinner {\n    flex: 0 0 auto;\n    margin-right: 0.25em;\n    width: 1.5em;\n    height: 1.5em;\n}\n\ndiv.resizeable-window-titlebar > div.spinner > div {\n    background-color: var(--titlebar-text-color);\n}\n\nspan.resizeable-window-titlebar-icon {\n    flex: 0 0 auto;\n    margin-right: 0.25em;\n}\n\nspan.resizeable-window-titlebar-title {\n    font-weight: bold;\n    flex: 1 1 auto;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    overflow: hidden;\n}\n\nspan.resizeable-window-titlebar-control {\n    flex: 0 0 auto;\n    margin-left: 0.25em;\n    font-size: large;\n}\n\nspan.resizeable-window-titlebar-extra-control {\n    flex: 0 0 auto;\n    margin-right: 0.25em;\n    font-size: large;\n}\n\nspan.resizeable-window-titlebar-extra-control-active {\n    background-color: var(--titlebar-text-color);\n    color: var(--titlebar-bg-color);\n}\n\ndiv.resizeable-window-body {\n    overflow: hidden;\n    flex: 1 1 auto;\n    cursor: default;\n    flex: 1 1 auto;\n    position: relative;\n    border-radius: 0px 0px var(--border-radius) var(--border-radius);\n}\n\ndiv.dock-window > div.resizeable-window-body {\n    margin: 0.25em;\n}\n\ndiv.resizeable-window-body-scrollable {\n    overflow-y: auto;\n}\n\ndiv.resizeable-window-drag-shield {\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    display: none;\n    z-index: 1;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
